import styled from 'styled-components';
import React from 'react';
import { Checkbox, Icon, ProgressIndicator, Text, Pagination, IconButton, TextButton, SelectField, } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_XL, SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_COLOR_SURFACE_NEUTRAL_800_DARK, SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_450, SYS_SIZE_FIXED_500, SYS_SPACE_FIXED_600, } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '../../utils';
import { CMP_COLOR_UI_TAG_SELECTED_TEXT_DEFAULT_DARK, SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK, SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK, SYS_COLOR_CANVAS_200_DARK, SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK, SYS_COLOR_STATIC_900_SOLID_DARK, SYS_COLOR_SURFACE_NEUTRAL_600_DARK, SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT, SYS_SPACE_RELATIVE_2_XL, SYS_SPACE_RELATIVE_3_XL, } from '@oneaudi/unified-web-alpha-common';
const clusterSvgAlpha = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4479_86811)">
<path d="M24 47.5C36.9787 47.5 47.5 36.9787 47.5 24C47.5 11.0213 36.9787 0.5 24 0.5C11.0213 0.5 0.5 11.0213 0.5 24C0.5 36.9787 11.0213 47.5 24 47.5Z" fill="#181D25" stroke="#9AA3B1"/>
<path d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z" fill="#9AA3B1"/>
</g>
<defs>
<clipPath id="clip0_4479_86811">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>
    `;
const encodedClusterIcon = encodeURIComponent(clusterSvgAlpha)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');
const dataUri = `"data:image/svg+xml;charset=UTF-8,${encodedClusterIcon}"`;
export const LocationFilterContainer = styled.div `
  width: 100%;
  position: relative;
`;
export const LocationFilterHeaderContainer = styled.div `
  width: 100%;
  padding-block-end: ${SYS_SPACE_FIXED_450};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding-block-end: ${dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_RELATIVE_2_XL)};
  }
`;
export const LocationFilterBodyContainer = styled.div `
  --height-map-dealerslist-mobile: calc(((100vw - (2 * var(--spacing-relative-lg))) / 3) * 4);
  --height-map-dealerslist-tablet: calc(((100vw - (2 * var(--spacing-relative-lg))) / 4) * 3);
  --height-map: 547px;
  --height-dealerslistheaderfooter: 53px;
  --height-dealerslist: calc(var(--height-map) - 2 * var(--height-dealerslistheaderfooter));
  /* this is only part of the gap, the rest of the "visual gap" is added to the dealerListContainer so that the scrollbar is not touching the map */
  --column-gap: 6px;

  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  column-gap: var(--column-gap);
  background-color: transparent;
  margin-block-end: ${dynamicStylingHelper(SYS_SPACE_FIXED_450, SYS_SPACE_RELATIVE_3_XL)};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    grid-template-columns: 1fr 1fr;
    overflow: auto;
    margin-block-end: ${dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_RELATIVE_3_XL)};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    grid-template-columns: 1fr 2fr;
  }

  .marker_base {
    display: flex;
    width: auto;
    height: 40px;
  }
  .marker--disabled {
    pointer-events: none !important;
  }

  .marker_cluster {
    background-image: ${dynamicStylingHelper(`url("data:image/svg+xml,%3Csvg width='44' height='43' viewBox='0 0 44 43' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M44 0H0V36H14.9289L22 43.0711L29.0711 36H44V0Z' fill='black'/%3E%3C/svg%3E")`, `url(${dataUri})`)};
    align-items: center;
    justify-content: center;
    color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT, SYS_COLOR_STATIC_900_SOLID_DARK)};
    padding-block-end: ${dynamicStylingHelper('6px', 'unset')};
    box-sizing: border-box;
    width: ${dynamicStylingHelper('44px', '48px')};
    height: ${dynamicStylingHelper('43px', '48px')};
  }
`;
export const LocationInputContainer = styled.div `
  width: 100%;
  display: grid;
  align-items: end;
  grid-template-columns: auto;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: 45% 25%;
    grid-column-gap: 5%;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: ${dynamicStylingHelper('57px', 'unset')};
    grid-template-columns: auto auto auto;
    margin-top: unset;
    grid-column-gap: unset;
  }
`;
export const SearchWrapper = styled.div `
  display: grid;
  width: 100%;
  grid-template-columns: ${dynamicStylingHelper('93% auto', 'unset')};
  align-items: center;

  label {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
export const DealerNameAndCount = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const StyledSelect = styled((props) => React.createElement(SelectField, Object.assign({}, props))) `
  margin-top: ${SYS_SPACE_FIXED_300};
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-top: ${dynamicStylingHelper('none', 'unset')};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-inline-start: 36px;
  }
`;
export const StyledCheckboxAllDealersChosen = styled((props) => (React.createElement(Checkbox, Object.assign({}, props)))) `
  padding-block-start: ${SYS_SPACE_FIXED_200};
  border-block-start: 1px solid hsla(0, 0%, 85%, 1);

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding-block-start: 9px;
    padding-block-end: 9px;
    margin-inline-end: 32px;
  }
`;
export const StartBorderDiv = styled.div `
  border-block-start: ${dynamicStylingHelper('1px solid hsla(0, 0%, 85%, 1)', `2px solid ${SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK}`)};
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: calc(100% - (var(--spacing-relative-lg) + 6px));
  }
`;
export const LocateMeButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) `
  min-width: 24px;
  max-width: 36px;
  min-height: 24px;
  max-height: 36px;
  :disabled {
    box-shadow: none;
  }

  button {
    width: 100%;
    margin-left: ${SYS_SIZE_FIXED_500};
  }

  /* locate-me icon and delete text */
  svg {
    flex: 1 0 24px;
  }
`;
export const ClearAllLocationsButton = styled((props) => (React.createElement(TextButton, Object.assign({}, props)))) `
  margin-top: ${SYS_SPACE_FIXED_300};
  justify-self: start;
  justify-content: start;
  ${dynamicStylingHelper('padding: 0px')};
  min-height: unset;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-top: unset;
    justify-self: end;
    justify-content: end;
  }
`;
export const MapBlockedContainer = styled.div `
  background-color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_800_DARK, SYS_COLOR_SURFACE_NEUTRAL_600_DARK)};
  min-height: var(--height-map-dealerslist-mobile);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    min-height: var(--height-map-dealerslist-tablet);
    border-radius: ${dynamicStylingHelper('unset', '20px')};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    min-height: var(--height-map);
    margin-inline-start: 24px;
  }
`;
export const MapConsentRequestButton = styled((props) => (React.createElement(TextButton, Object.assign({}, props)))) `
  width: auto;
  margin-top: var(--spacing-relative-lg);
`;
export const StyledEyeCrossedIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  color: ${SYS_COLOR_SURFACE_NEUTRAL_100_DARK};
  margin-bottom: ${SYS_SPACE_FIXED_150};
`;
export const StyledApprovalText = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  color: ${SYS_COLOR_SURFACE_NEUTRAL_100_DARK};
`;
export const ConsentRequestWrapperMobile = styled.div `
  padding: 0 0 var(--spacing-relative-2xl);

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: 0 0 var(--spacing-relative-xl);
  }
`;
export const CookieConsentRequestContainer = styled.div `
  display: flex;
  align-items: flex-start;
  padding: ${SYS_SPACE_FIXED_200};
  gap: var(--spacing-relative-sm);
  height: fit-content;
  margin-bottom: ${(props) => props.isMas && dynamicStylingHelper('0', SYS_SPACE_FIXED_300)};

  /* the i-icon */
  svg {
    flex: 1 0 24px;
  }

  background-color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_600_DARK)};
  border-radius: ${dynamicStylingHelper('unset', '20px')};
`;
export const CookieConsentRequestContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_200};
`;
export const CookieConsentControlContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: ${SYS_SPACE_FIXED_200};
  margin-block-start: ${SYS_SPACE_FIXED_450};
  margin-inline-end: ${SYS_SPACE_FIXED_200};
  gap: ${SYS_SPACE_FIXED_150};
  height: fit-content;
  box-sizing: border-box;

  svg {
    flex: 1 0 24px;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-block-start: unset;
    margin-block-end: ${dynamicStylingHelper('unset', SYS_SPACE_RELATIVE_3_XL)};
  }

  background-color: ${dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_600_DARK)};
  border-radius: ${dynamicStylingHelper('unset', '20px')};
`;
export const DealersListContainer = styled.div `
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  position: ${(props) => (props.visible ? 'static' : 'absolute')};
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  flex-direction: column;
  left: ${(props) => (props.visible ? 'unset' : '1000%')};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: flex;
    flex-direction: column;
  }
`;
export const DealersListHeaderWrapper = styled.div `
  padding-block-start: ${SYS_SPACE_FIXED_200};
  padding-block-end: ${SYS_SPACE_FIXED_200};
  display: flex;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding-block-end: ${SYS_SPACE_FIXED_200};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    /* The 32px margin is needed to have enough space for the scroll bar not to touch neither the divider lines nor the map */
    margin-inline-end: 32px;
    justify-content: space-between;
    padding-block-start: unset;
  }
`;
export const DealersListWrapper = styled.div `
  height: var(--height-map-dealerslist-mobile);

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: var(--height-map-dealerslist-tablet);
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    overflow: auto;
    height: var(--height-dealerslist);
    /* margin needed to create space between scrollbar and map */
    margin-inline-end: 6px;

    ${(props) => props.zeroResults && 'height:0; flex-grow: 1;'};
  }
`;
export const StyledAccordion = styled.div `
  min-height: 250px;
  border-block-end: ${dynamicStylingHelper('unset', `2px solid ${SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK}`)};
`;
export const DealersListAccordionWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledPagination = styled((props) => React.createElement(Pagination, Object.assign({}, props))) `
  align-self: center;
  margin-top: ${SYS_SPACE_FIXED_300};
  margin-bottom: ${SYS_SPACE_FIXED_300};
`;
export const RenderedDealersList = styled.div `
  height: calc(var(--height-map-dealerslist-mobile) - 66px);
  overflow: auto;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: calc(var(--height-map-dealerslist-tablet) - 66px);

    &::-webkit-scrollbar {
      width: auto;
    }
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: var(--height-dealerslist);
    padding-inline-end: var(--spacing-relative-lg);
    z-index: 1;
    position: relative;
    ${(props) => props.zeroResults && 'height:0;'};

    &::-webkit-scrollbar-thumb {
      background-color: ${dynamicStylingHelper('inherit', SYS_COLOR_SURFACE_NEUTRAL_600_DARK)};
      border-radius: ${dynamicStylingHelper('inherit', '7px')};
    }
  }
`;
export const DealersFoundContainer = styled.div `
  display: flex;
  flex-direction: row;
`;
export const DealersSelectedContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  margin-left: var(--spacing-relative-md);
  margin-right: var(--spacing-relative-2xs);
  color: ${dynamicStylingHelper('inherit', CMP_COLOR_UI_TAG_SELECTED_TEXT_DEFAULT_DARK)};

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-left: unset;
    margin-right: unset;
  }
`;
export const StyledLoader = styled((props) => (React.createElement(ProgressIndicator, Object.assign({ variant: "spinner", type: "infinite" }, props)))) `
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  z-index: 1;
`;
export const StyledText = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '2',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  max-width: 25%;
`;
export const StyledCountText = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK};
  align-self: self-start;
  margin-block-start: ${SYS_SPACE_FIXED_200};
  margin-left: var(--spacing-relative-sm);
  margin-right: var(--spacing-relative-sm);
  flex-basis: max-content;
  flex-shrink: 0;
`;
export const StyledCountSpan = styled.span `
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: inline;
  }
`;
export const StyledAddressText = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK};
`;
export const StyledAddressTextNextToIcon = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  grid-area: street;
  color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK};
`;
export const StyledAddressTextFullWidth = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  grid-area: city;
  color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK};
`;
export const StyledDistanceText = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '1',
        style: 'normal',
        type: 'copy',
    } }, props)))) `
  color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK};
`;
export const StyledAddressIcon = styled((props) => (React.createElement(Icon, Object.assign({ name: "poi", size: "s" }, props)))) `
  flex-shrink: 0;
  color: ${(props) => props.disabled
    ? SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK
    : dynamicStylingHelper('inherit', SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK)} !important;
  margin-right: ${SYS_SPACE_FIXED_150};

  > :before {
    color: ${(props) => props.disabled
    ? SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK
    : dynamicStylingHelper('inherit', SYS_COLOR_SURFACE_NEUTRAL_100_DARK)} !important;
  }
`;
export const StyledDistanceIcon = styled((props) => (React.createElement(Icon, Object.assign({ name: "distance", size: "s" }, props)))) `
  color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK} !important;
  margin-right: ${SYS_SPACE_FIXED_150};

  > :before {
    color: ${(props) => props.disabled && SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK} !important;
  }
`;
export const DealersListRef = styled.div `
  :first-child {
    border-block-start: ${dynamicStylingHelper('1px solid hsla(0, 0%, 85%, 1)', `2px solid ${SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK}`)};
  }
  :not(:last-child) {
    border-block-end: ${dynamicStylingHelper('1px solid hsla(0, 0%, 85%, 1)', `2px solid ${SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK}`)};
  }
`;
export const DealerListItemWrapper = styled.div `
  padding-block-end: ${SYS_SPACE_FIXED_200};
  background-color: ${(props) => props.status === 'focused' &&
    dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT, 'unset')};
`;
export const DealerDetails = styled.div `
  padding-left: 44px;
  pointer-events: none;

  :hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`;
export const Address = styled.div `
  display: inline-flex;
  flex-wrap: nowrap;
  pointer-events: none;
  padding-inline-end: var(--spacing-relative-sm);
`;
export const AddressMobile = styled.div `
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    'addressicon street street'
    '. city city';
`;
export const Distance = styled.div `
  display: flex;
  pointer-events: none;
  padding-block-start: var(--spacing-relative-sm);
  padding-inline-end: var(--spacing-relative-sm);
`;
export const Map = styled.div `
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  position: ${(props) => (props.visible ? 'relative' : 'absolute')};
  left: ${(props) => (props.visible ? 'unset' : '1000%')};
  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: var(--height-map-dealerslist-mobile);
  max-height: var(--height-map-dealerslist-mobile);

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    min-height: var(--height-map-dealerslist-tablet);
    max-height: var(--height-map-dealerslist-tablet);
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    min-height: var(--height-map);
    max-height: var(--height-map);
  }
  background: ${dynamicStylingHelper('#000000', SYS_COLOR_CANVAS_200_DARK)};

  &:after {
    display: ${(props) => (props.zeroResultsFound ? 'block' : 'none')};
    content: '';
    background: ${dynamicStylingHelper('#000000', SYS_COLOR_CANVAS_200_DARK)};
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .checked,
  .unchecked,
  .focused {
    pointer-events: all !important;
  }

  .disabled {
    pointer-events: none;
  }
`;
export const MapRef = styled.div `
  width: 100%;
  height: var(--height-map-dealerslist-mobile);
  border-radius: ${dynamicStylingHelper('unset', '20px')};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: var(--height-map-dealerslist-tablet);
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: var(--height-map);
  }
`;
export const FocusedDealerWrapper = styled.div `
  position: absolute;
  width: 100%;
  bottom: 0;
`;
export const ZeroResultsBannerWrapper = styled.div `
  z-index: 2;
  position: ${(props) => (props.isDisplayedOnMapTab ? 'absolute' : 'static')};
  width: calc(100% - (2 * var(--spacing-relative-lg)));
  top: 0;
  background-color: ${(props) => props.isDisplayedOnMapTab
    ? dynamicStylingHelper(SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_COLOR_SURFACE_NEUTRAL_600_DARK)
    : 'unset'};
  border-radius: ${dynamicStylingHelper('unset', '20px')};
  padding-top: var(
    ${(props) => props.isDisplayedOnMapTab ? '--spacing-relative-lg' : '--spacing-relative-2xl'}
  );
  padding-left: var(
    ${(props) => props.isDisplayedOnMapTab ? '--spacing-relative-lg' : '--spacing-relative-md'}
  );
  padding-right: var(
    ${(props) => props.isDisplayedOnMapTab ? '--spacing-relative-lg' : '--spacing-relative-md'}
  );
  padding-bottom: var(
    ${(props) => (props.isDisplayedOnMapTab ? '--spacing-relative-lg' : 'unset')}
  );

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: var(--spacing-relative-2xl) var(--spacing-relative-lg);
  }
`;
